import {Component} from '@angular/core';
import {UrlService} from '../../../services/url.service';
import {SettingsKeyLogService} from '../../../services/settings-key-log.service';

declare const toastr: any;
declare const $: any;

@Component({
    selector: 'corporations-list',
    templateUrl: './corporations-list.component.html',
    styleUrls: ['./corporations-list.component.scss']
})
export class CorporationsListComponent {

    constructor(
        public urlService: UrlService,
        public settingsKeyLogService: SettingsKeyLogService
    ) {}

    orderBy(orderBy: string, $event) {
        if (this.settingsKeyLogService.data.corporations.total < 2) return;
        this.urlService.orderBy(orderBy, $event);
    }

    toggleCheck(selectedItem): void {
        const checked = selectedItem.checked;
        this.uncheckItem();
        if (checked && this.settingsKeyLogService.selectedItemData) {
            this.settingsKeyLogService.chosenCorporation = null;
            this.settingsKeyLogService.toggleDetailedView(null, false);
        } else {
            this.settingsKeyLogService.chosenCorporation = selectedItem;
            selectedItem.checked = true;
            // get website builder settings for corporation before toogling
            this.settingsKeyLogService.toggleDetailedView(selectedItem, true);
        }
    }

    uncheckItem(): void {
        this.settingsKeyLogService.data.corporations.data.forEach((item) => item.checked = false);
    }

    showHint(e) {
        e.stopPropagation();
        const $td = $(e.target).closest('.table-hint-td');
        if ($td.hasClass('active'))
            $td.removeClass('active');
        else {
            $('.table-hint-td').removeClass('active');
            $td.addClass('active');
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-key-log/corporations-list/corporations-list.component.ts